import { useEffect, useState } from 'react'
import './styles/FlujoModal.css'

import LoadSimple from '../LoadSimple'
import InternalError from '../generales/InternalError'
import { capitalizeFirstLetter } from '../../utils/utils';
import { lang } from '../generales/traduction';
import FinalStatus1 from './FinalStatus';
import { FlexboxGrid } from 'rsuite';
const FlujoModal = ({ eventId ,props}) => {
    const token_item=localStorage.getItem('access_token')
    const [dataFlujo,setDataFlujo]=useState({data:[],loading:true,error:null})
    //    console.log(props.data)
    //    eventId=34990088
    const [flujoList,setFlujoList]=useState([])
    const [internalError,setInternalError]=useState(false)
    useEffect(()=>{
        search_event()
    },[])
    function search_event(){
        setDataFlujo({data:{},loading:true,error:dataFlujo.error})
          const fetchData = async () => {
              try {
                  const url=(props.data.alert_type=="correlation")?props.server.url+'/api/v1/cassia/events_correlations/acknowledge/'+eventId:props.server.url+'/api/v1/zabbix/problems/acknowledge/'+eventId+'?is_cassia_event='+((props.data.alert_type=="")?0:1)
                  const response = await fetch(url, {                 
                                         headers: {
                                           'Content-Type': 'application/json',
                                           Authorization: `Bearer ${token_item}`,
                                         },
                                       });
                  if (response.ok) {
                      const response_data = await response.json();

                      // flujoObject(response_data.data)

                      setDataFlujo({data:response_data.data,loading:false,error:dataFlujo.error})
                      // setDataFlujo(response_data.data)
                  } else {
                      throw new Error('Error en la solicitud');
                  }
              } catch (error) {
                  setInternalError(true)
              }
          };
          fetchData();
      }
    const flujoObject=(data)=>{
        //         const fecha1 = new Date(data.tickets.created_at);
        // const fecha2 = new Date(data.history.Time);
        const objeto1ConFechas = data.tickets.map(obj => ({ ...obj, comparativeTime: new Date(obj.created_at)  }));
        const objeto2ConFechas = data.history.map(obj => {
            const [dia, mes, anio, hora, minuto, segundo] = obj.Time.split(/\/|\s|:/);
            const fecha = new Date(`${anio}-${mes}-${dia}T${hora}:${minuto}:${segundo}`);
            return { ...obj, comparativeTime: fecha };
          });
        // const objeto2ConFechas = data.history.map(obj => ({ ...obj, Time: obj.Time }));

        // Combinar los arreglos de objetos
        const objetosCombinados = [...objeto1ConFechas, ...objeto2ConFechas];

        // Ordenar el arreglo combinado por fecha
        objetosCombinados.sort((a, b) => {
          if (a.comparativeTime && b.comparativeTime) {
            return a.comparativeTime - b.comparativeTime;
          }
          return 0;
        });

        setFlujoList(objetosCombinados)
    }
    return(
        
            (internalError)?<InternalError></InternalError>:
            <div className='contFlujoModal'>
            <div className='headContFlujoModal'>
            {capitalizeFirstLetter(lang[props.languaje]['flujoEvento'])}: {eventId}
                
            </div>
            
            <div className='bodyContFlujoModal'>
                {

                (dataFlujo.loading)?<div className='contflujoload'><LoadSimple/></div>:

                <>
                {/* Inicio */}
                {/* <div className='rowLevel' style={{height:'10%'}}>
                    <div className='rowSide leftSideRow'>

                    </div>
                    <div className='rowSide RightSideRow'>
                        <div className='consArrowflujo arrowLeft'></div>
                        <div className='contInfoFlujo'>
                            <div className='contTopInfoFlujo'>
                            <div className='contTopRightFlujo impar'>
                                        <div className='txtTimeFlujo '>
                                            {props.data.Time}
                                        </div>
                                </div>
                                
                                
                            </div>
                            <div className='contBotInfoFlujo'>
                            
                                <div className='contBotRightFlujo'>
                                        <div className='contMsgFlujo' style={{justifyContent:'left',fontWeight:'bold'}}>
                                            Inicio de evento
                                        </div>   
                                       
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div> */}
               {
                //  dataFlujo.data.history.map((element, index) => {
                    dataFlujo.data.map((element, index) => {
                        // <div>{element.type}</div>
                    if(element.type=="Progreso del evento a la fecha."){
                        return <>
                        <div className='rowLevel' style={{height:'auto',display:'flex',justifyContent:'center'}}>
                            <FinalStatus1 status={props.data.Estatus} hrs={element.message.replace('Acumulado del evento:','')}/>
                    {/* <div className='rowSide leftSideRow' style={{height:'auto',width:'100%',border:'unset'}}>
                    
                        <div className='contInfoFlujo' style={{height:'auto',top:'10px',width:'50%'}}>

                            <div className='contTopInfoFlujo' style={{height: '30px'}}>
                                <div className='contTopLeftFlujo'>
                                        <div className='txtStatusFlujo  ENPROCESO'>
                                        {capitalizeFirstLetter(lang[props.languaje]['enProceso'])}
                                        </div>
                                </div>
                                <div className='contTopRightFlujo par'>
                                        <div className='txtTimeFlujo '>
                                            {dataFlujo.data.date}
                                        </div>
                                </div>
                            </div>
                            <div className='contBotInfoFlujo'>
                                <div className='contBotRightFlujo' style={{width:'100%'}}>
                                        <div className='contMsgFlujo' style={{height:'35%',color:'#ec5141'}}>
                                        {capitalizeFirstLetter(lang[props.languaje]['acumuladoEvento'])}:<p style={{color:'black'}}>&nbsp;{'  '+element.message.replace('Acumulado del evento:','')}</p> 
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
                </>
                    }else if(index%2==0){
                        return <>
                        {/* der */}
     <div className='rowLevel'>
                    <div className='rowSide leftSideRow'>
                    <div className='consArrowflujo arrowRight'></div>
                        <div className='contInfoFlujo'>
                            <div className='contTopInfoFlujo'>
                                <div className='contTopLeftFlujo'>

                                        <div className='txtStatusFlujo ' style={{color:'var(--second-color)',backgroundColor: '#c3d3fe',border: '1px solid var(--second-color)',borderRadius: '6px',padding: '5px 14px'}}>
                                        {capitalizeFirstLetter(lang[props.languaje][element.type])} 
                                        </div>

                                </div>
                                <div className='contTopRightFlujo par'>
                                        <div className='txtTimeFlujo '>
                                            {element.date.replace("T", " ")}
                                        </div>
                                </div>
                            </div>
                            <div className='contBotInfoFlujo'>
                            {/* <div className='contBotLeftFlujo'>
                            <div className='contTicketInfo'>

                                            {
                                                (element.tickets!="")?'Tickets:':''
                                            } 

                                        </div>
                                        {element.tickets.slice(2).split(',').map(item =>{ 
                                            return <div className='contTicketInfo'>
                                             {item}
                                        </div>
                                        }
                                            )}
                                </div> */}
                                <div className='contBotRightFlujo'>
                                        <div className='contMsgFlujo par'>
                                            {(element.ticket_id===undefined)?element.message.replaceAll("-", "\n"):'Tracker ID: '+element.tracker_id}
                                        </div>   
                                        <div className='contMsgBotFlujo par'>
                                        {(element.ticket_id===undefined)?element.user:'Ticket'}
                                        </div>  
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='rowSide RightSideRow'>
                        
                    </div>
                </div>
                        </>
                    }else{
                        return <>
                    {/* izq */}
                 <div className='rowLevel'>
                    <div className='rowSide leftSideRow'>

                    </div>
                    <div className='rowSide RightSideRow'>
                        <div className='consArrowflujo arrowLeft'></div>
                        <div className='contInfoFlujo'>
                            <div className='contTopInfoFlujo'>
                            <div className='contTopRightFlujo impar'>
                                        <div className='txtTimeFlujo '>
                                        {element.date.replace("T", " ")}
                                        </div>
                                </div>
                                <div className='contTopLeftFlujo'>

                                        <div className='txtStatusFlujo ' style={{color:'var(--second-color)',backgroundColor: '#c3d3fe',border: '1px solid var(--second-color)',borderRadius: '6px',padding: '5px 14px' }}>
                                            {capitalizeFirstLetter(lang[props.languaje][element.type])}
                                        </div>

                                </div>
                                
                            </div>
                            <div className='contBotInfoFlujo'>
                            
                                <div className='contBotRightFlujo'>
                                        <div className='contMsgFlujo impar'>
                                        {(element.ticket_id===undefined)?element.message.replaceAll("-", "\n"):'Tracker ID: '+element.tracker_id}
                                        </div>   
                                        <div className='contMsgBotFlujo impar'>
                                        {(element.ticket_id===undefined)?element.user:'Ticket'}
                                        </div>  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    </>
                    }
                    
                  })
               
               }
 
                 

              

                    
                <div style={{height:'30px'}}></div>

                </>
                }
            </div>
        </div>
        
    )
}

export default FlujoModal
